import { BaseApiMethodExecutor } from '../../api/BaseApiMethodExecutor/BaseApiMethodExecutor';
import { ApiMethodExecutingError } from '../../service/Errors';
import { CanvasApiBaseResponse } from '../common/requestsTypings';
import { SharedData } from '../common/typings';

export const CANVAS_API_PATH = '/canvas-api/';

const canvasHeaders = {
    Accept: 'application/json, text/javascript, */*; q=0.01',
    'Accept-encoding': 'gzip, deflate',
    Connection: 'keep-alive'
};

export class CanvasApiMethodExecutor extends BaseApiMethodExecutor {
    constructor(apiPath?: string) {
        super(apiPath || CANVAS_API_PATH);
    }

    protected get defaultHeaders(): HeadersInit {
        return { ...this._defaultHeaders, ...canvasHeaders };
    }

    protected get headersWithoutContentType(): HeadersInit {
        const headers = { ...this.defaultHeaders };
        delete headers['Content-Type'];

        return headers;
    }

    async createRequest<T extends CanvasApiBaseResponse>(
        path: string,
        params: RequestInit = {},
        sharedData?: SharedData,
        queryParams?: string[]
    ): Promise<T> {
        const query = queryParams || [];
        if (sharedData) {
            query.push(
                `shared_data=${encodeURIComponent(JSON.stringify(sharedData))}&client_id=${sharedData.clientId}`
            );
        }
        const newPath = `${path}${query.length > 0 ? `?${query.join('&')}` : ''}`;

        params.headers = params.headers || this.defaultHeaders;
        params.headers['X-Detected-Locale'] = process.env.BEM_LANG || 'ru';
        params.headers['Accept-Language'] = process.env.BEM_LANG || 'ru';

        const data = await super.createRequest<T>(newPath, params);

        if (data.error && data.message) {
            throw new ApiMethodExecutingError({ message: data.message });
        }

        return data;
    }
}
